module.exports = __webpack_public_path__ + "img/Launch-Admin-Logo-Light.170e444d.svg";